/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Tenant } from './Tenant.js';
import {
    TenantFromJSON,
    TenantFromJSONTyped,
    TenantToJSON,
} from './Tenant.js';

/**
 * 
 * @export
 * @interface GetTenantsResponse
 */
export interface GetTenantsResponse {
    /**
     * 
     * @type {Array<Tenant>}
     * @memberof GetTenantsResponse
     */
    data?: Array<Tenant>;
    /**
     * 
     * @type {number}
     * @memberof GetTenantsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTenantsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTenantsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetTenantsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetTenantsResponse interface.
 */
export function instanceOfGetTenantsResponse(value: object): boolean {
    return true;
}

export function GetTenantsResponseFromJSON(json: any): GetTenantsResponse {
    return GetTenantsResponseFromJSONTyped(json, false);
}

export function GetTenantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTenantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TenantFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetTenantsResponseToJSON(value?: GetTenantsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TenantToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

